import {
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  SkeletonText,
} from "@chakra-ui/react";
import { format } from "date-fns";

import DeleteIcon from "@/assets/DeleteIcon";
import EditIcon from "@/assets/EditIcon";
import ApprovedIcon from "@/assets/ApprovedIcon";
import PaidIcon from "@/assets/PaidIcon";
import RejectIcon from "@/assets/RejectIcon";
import UnpaidIcon from "@/assets/UnpaidIcon";
import DraftIcon from "@/assets/DraftIcon";
import SentIcon from "@/assets/SentIcon";
import FileIcon from "@/assets/FileIcon";
import InProgress from "@/assets/InProgress";
import FinanceIcon from "@/assets/FinanceIcon";
import { capitalizeFirstLetter } from "@/utils/letter";
import Pagination from "../Layouts/Pagination";
import { COLORS, INVOICE_STATUS } from "@/common/constants";
import { getCurrencySymbol } from "@/utils/currency";

const TableInvoiceShipOwnerSuperAdmin = ({ dataList, isLoading, handleEdit, handleDelete, currentPageSize, handleChangePageSize, handleChangePageNumber, currentPageNumber, totalPageNumber, hasNextPage, handleDownload }: any) => {
    const NUM_COLUMNS = 12;
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Order Number</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Type</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>SIRE Type</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Market</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Invoice ID</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>PO Number</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Invoice Date</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Company Name</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Address</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Vessel Name</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Amount</Th>
                            {/* <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>PPN (%)</Th> */}
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>PPN (Amount)</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Invoice Status</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Payment Status</Th>
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>File</Th>
                            {/* <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Payment Confirmation</Th> */}
                            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {isLoading &&
                            <Tr>
                                <Td colSpan={NUM_COLUMNS}>
                                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                                </Td>
                            </Tr>
                        }
                        {(!isLoading && (!dataList || dataList.length === 0)) &&
                            <Tr>
                                <Td colSpan={NUM_COLUMNS} textAlign="center">Data not found</Td>
                            </Tr>
                        }
                        {!isLoading && dataList?.map((item: any) => {
                            return (
                                <Tr key={item.id}>
                                    <Td>{item.sequenceID || '-'}</Td>
                                    <Td textAlign='center'>{capitalizeFirstLetter(item.type) || '-'}</Td>
                                    <Td>{capitalizeFirstLetter(item.sireType) || '-'}</Td>
                                    <Td>{item.market || '-'}</Td>
                                    <Td>{item.invoiceID || '-'}</Td>
                                    <Td>{item.poNumber|| '-'}</Td>
                                    <Td>{item.invoiceDate ? format(item.invoiceDate, 'dd-MM-yyyy') : '-'}</Td>
                                    <Td>{item.companyName}</Td>
                                    <Td>{item.address|| '-'}</Td>
                                    <Td>{item.shipName}</Td>
                                    <Td textAlign='right'>{item.currency ? getCurrencySymbol(item.currency, item.amount) : '-'}</Td>
                                    {/* <Td textAlign='right'>{item.isPPN ? item.ppn : '-'}</Td> */}
                                    <Td textAlign='right'>{item.currency ? getCurrencySymbol(item.currency, item.ppnPrice) : '-'}</Td>
                                    <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.invoiceStatus === 0 && <DraftIcon />}
                                            {item.invoiceStatus === 1 && <SentIcon />}
                                            {item.invoiceStatus === 2 && <ApprovedIcon />}
                                            {item.invoiceStatus === 3 && <RejectIcon />}
                                            {item.invoiceStatus === 4 && <FinanceIcon />}
                                        </div>
                                    </Td>
                                    <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.paymentStatus === 0 && <UnpaidIcon />}
                                            {item.paymentStatus === 1 && <InProgress />}
                                            {item.paymentStatus === 4 && <PaidIcon />}
                                            {item.paymentStatus === 3 && <RejectIcon />}
                                        </div>
                                    </Td>
                                    <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            {item.downloadId && <FileIcon style={{ cursor: 'pointer' }} onClick={() => handleDownload(item.downloadId, 0)} />}
                                            {!item.downloadId && <p>-</p>}
                                        </div>
                                    </Td>
                                    {/* <Td>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button bgColor='#079455' borderRadius='full' color='white' height='25px' onClick={() => handlePay(item.id)} isDisabled={item.paymentStatus !== 1}>Confirm</Button>
                                        </div>
                                    </Td> */}
                    <Td
                      style={{
                        display: "flex",
                        cursor: "pointer",
                        gap: 8,
                        justifyContent: "center",
                        paddingTop: "26px",
                        paddingBottom: "26px",
                      }}
                    >
                      {item.invoiceStatus === INVOICE_STATUS.DRAFT ||
                      item.invoiceStatus === INVOICE_STATUS.REJECTED ? (
                        <>
                          <EditIcon onClick={() => handleEdit(item.id)} />
                          <DeleteIcon onClick={() => handleDelete(item.id)} />
                        </>
                      ) : (
                        item.invoiceStatus !== 0 && <p>-</p>
                      )}
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </Box>
      <Pagination
        currentPageSize={currentPageSize}
        currentPageNumber={currentPageNumber}
        totalPageNumber={totalPageNumber}
        handleChangePageSize={handleChangePageSize}
        handleChangePageNumber={handleChangePageNumber}
        hasNextPage={hasNextPage}
      />
    </TableContainer>
  );
};

export default TableInvoiceShipOwnerSuperAdmin;
